import(/* webpackMode: "eager" */ "/app/src/app/[locale]/terms-and-conditions/error.tsx");
